module.exports = __webpack_public_path__ + "static/img/industrial-fluid-buffer_64.ae972ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industrial-fluid-buffer_64.png
// module id = AhzV
// module chunks = 0